import { config } from '../_config';
import { authHeader, handleResponse } from '../_helpers';

export const dogService = {
  getAll,
  getById,
  getBreeds,
  getBooks,
  update,
  create,
  delete: _delete,
  getClasses
};

function getAll() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/dogs`, requestOptions).then(handleResponse);
}


function getById(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/dogs/${id}`, requestOptions).then(handleResponse);
}

function getByUserId(id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/dogs/user/${id}`, requestOptions).then(handleResponse);
}

function update(dog) {
  const requestOptions = {
    method: 'PUT',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(dog)
  };

  return fetch(`${config.apiUrl}/dogs/${dog.id}`, requestOptions).then(handleResponse);
}

function create(dog) {
  const requestOptions = {
    method: 'POST',
    headers: { ...authHeader(), 'Content-Type': 'application/json' },
    body: JSON.stringify(dog)
  };

  return fetch(`${config.apiUrl}/dogs`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  };
  return fetch(`${config.apiUrl}/dogs/${id}`, requestOptions).then(handleResponse);
}

/*
DogBreeds
*/
function getBreeds() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }

  return fetch(`${config.apiUrl}/breeds`, requestOptions).then(handleResponse)
    .then(response => {      
      localStorage.setItem('dogBreeds', JSON.stringify(response))
      return response
    })
}

/*
DogBooks
*/
function getBooks() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/books`, requestOptions).then(handleResponse);
}

/*
DogClasses
*/
function getClasses() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${config.apiUrl}/getDogClasses`, requestOptions).then(handleResponse)
    .then(response => {
      localStorage.setItem('dogClasses', JSON.stringify(response.data));
      return response
    })
}
